<template>
  <v-app v-if="isAuthenticated">
    <v-navigation-drawer
      v-model="showDrawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <div v-if="isDefensoria">
        <v-img
          contain
          class="ma-3"
          height="200"
          widht="200"
          max-height="250"
          max-width="250"
          src="/assets/defensoria.png"
        />
      </div>
      <v-list dense>
        <template v-for="item in computedMenuItems">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            :prepend-icon="item.icon"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.link"
              link
            >
              <v-list-item-content>
                <v-list-item-title class="subtitle ml-1">
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else-if="item.click"
            :key="item.text"
            @click="item.click"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-else :key="item.text" :to="item.link" link>
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      color="primary"
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      dark
    >
      <v-app-bar-nav-icon
        @click.stop="showDrawer = !showDrawer"
      ></v-app-bar-nav-icon>
      <v-toolbar-title
        class="px-0 ml-0 mr-md-10 align-center hidden-sm-and-down"
      >
        <span class="title">COPRA</span>
      </v-toolbar-title>
      <v-text-field
        flat
        solo-inverted
        hide-details
        clearable
        prepend-inner-icon="mdi-magnify"
        label="Buscar"
        class="mr-4"
        autocomplete="off"
        v-model="search.query"
        @keydown.enter="doSearch"
        @click:clear="clearSearch"
        v-if="showTopSearchComputed"
      ></v-text-field>
      <v-menu
        v-model="search.datesMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        min-width="240px"
        transition="scale-transition"
        offset-y
        v-if="showTopSearchComputed && showDateSearchComputed"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="searchDateRangeText"
            label="Rango de Fechas"
            prepend-inner-icon="event"
            flat
            solo-inverted
            hide-details
            clearable
            readonly
            v-bind="attrs"
            v-on="on"
            @click:clear="clearDateSearch"
            width="180"
            height="20"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="search.dates"
          no-title
          range
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="
              search.datesMenu = false;
              search.dates = [];
            "
            >Cancel</v-btn
          >
          <v-btn
            text
            color="primary"
            @click="
              search.datesMenu = false;
              doDateSearch();
            "
            >OK</v-btn
          >
        </v-date-picker>
      </v-menu>
      <v-spacer class="hidden-sm-and-down"></v-spacer>
      <v-btn class="hidden-sm-and-down" icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main>
      <v-snackbar
        v-model="notificationsSnack.show"
        :color="notificationsSnack.color"
        timeout="5000"
        class="mb-6"
        bottom
      >
        {{ notificationsSnack.text }}
        <v-btn text @click="notificationsSnack.show = false">Close</v-btn>
      </v-snackbar>
      <v-container
        :class="{
          'pa-0': isDashboardView,
        }"
        fluid
      >
        <router-view></router-view>
      </v-container>
      <v-snackbar
        v-model="taskSnack.show"
        color="white"
        timeout="-1"
        class="pr-2"
        bottom
        right
      >
        <v-progress-circular
          v-show="taskSnack.loading"
          color="primary"
          width="2"
          size="20"
          class="mr-2"
          indeterminate
        ></v-progress-circular>
        <a v-if="taskSnack.url" :href="taskSnack.url" download>{{
          taskSnack.text
        }}</a>
        <span style="color: rgba(0, 0, 0, 0.87)" v-else>{{
          taskSnack.text
        }}</span>
        <template v-slot:action="{ attrs }">
          <v-btn
            text
            color="primary"
            v-bind="attrs"
            @click="taskSnack.show = false"
          >
            Cerrar
          </v-btn>
        </template>
      </v-snackbar>
    </v-main>
  </v-app>
  <v-app v-else>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
const PUBLIC_ACCOUNT_UID = "0ca6ef14-99a2-3e40-4602-3a609afdb06c";
import { checkInterval } from "@/commons/util.js";

import { mapMutations } from "vuex";
import { LOGOUT } from "@/store/mutation-types";

export default {
  props: {
    copraUrl: { type: String, default: process.env.VUE_APP_COPRA_SERVER_URL },
  },
  components: {},
  data() {
    return {
      showBar: true,
      showDrawer: false,
      showTopSearch: true,
      showMobileSearch: false,
      showDateSearch: true,
      search: {
        query: "",
        dates: [],
        dateRange: [],
        datesMenu: false,
      },
      notificationsSnack: {
        show: false,
        text: "test",
        color: "",
      },
      taskSnack: {
        show: false,
        loading: false,
        text: "",
        url: "",
      },
    };
  },
  created() {
    this.$eventBus.$on("showNotification", this.showNotification);
    this.$eventBus.$on("hideNotification", this.hideNotification);
    this.$eventBus.$on("newTask", this.newTask);
    this.$eventBus.$on("hideTask", this.hideTask);
    this.$eventBus.$on("setSearchInput", this.setSearchInput);
    this.$eventBus.$on("clearSearchInput", this.clearSearchInput);
  },
  methods: {
    ...mapMutations([LOGOUT]),
    showNotification(text, color) {
      this.notificationsSnack.show = true;
      this.notificationsSnack.text = text;
      this.notificationsSnack.color = color;
    },
    hideNotification() {
      this.notificationsSnack.show = false;
      this.notificationsSnack.text = "";
      this.notificationsSnack.color = "";
    },
    async newTask({ taskType, taskData }) {
      console.log("newTask", taskType, taskData);
      switch (taskType) {
        case "exportData":
          {
            this.downloadMetadata(taskData);
          }
          break;
        default: {
          this.hideTask();
        }
      }
    },

    hideTask() {
      this.taskSnack.show = false;
      this.taskSnack.loading = false;
      this.taskSnack.text = "";
      this.taskSnack.url = "";
    },
    setSearchInput({ query, dates }) {
      this.search.query = query;
      this.search.dates = dates;
    },
    clearSearchInput() {
      this.search.query = "";
      this.search.dates = [];
      this.search.datesMenu = false;
    },

    downloadMetadata(taskData) {
      this.taskSnack.show = true;
      this.taskSnack.loading = true;
      this.taskSnack.text = "Generando archivo...";
      let { datasetUid, format } = taskData;
      this.$http
        .post("/api/metadata", { datasetUid, format })
        .then(async (response) => {
          console.log(response);
          if (response.data.status == "OK") {
            let taskResponse = await checkInterval(() => {
              return this.$http.get(
                `/api/metadata/${response.data.metadataToken}`
              );
            });
            console.log("taskResponse", taskResponse);
            if (taskResponse.data) {
              this.taskSnack.loading = false;
              this.taskSnack.url = `${this.copraUrl}/api/metadata/${taskResponse.data.metadataToken}/download?jwt=${this.userToken}`;
              this.taskSnack.text = "Descargar";
              setTimeout(this.hideTask, 30000);
            }
          }
        });
    },
    sortDateRange(dateRange) {
      if (dateRange.length == 2) {
        let date1 = new Date(dateRange[0]);
        let date2 = new Date(dateRange[1]);
        if (date1 < date2) {
          return dateRange;
        } else {
          return [dateRange[1], dateRange[0]];
        }
      }
    },
    doSearch() {
      this.$eventBus.$emit("doKeywordSearch", this.search.query);
    },
    doDateSearch() {
      console.log("doDateSearch");
      this.$eventBus.$emit("doDateSearch", this.search.dates);
    },
    clearSearch() {
      this.search.query = "";
      this.$eventBus.$emit("doKeywordSearch", "");
    },
    clearDateSearch() {
      this.search.dates = [];
      this.$eventBus.$emit("doDateSearch", null);
    },
  },
  computed: {
    userToken() {
      return this.$store.state.userToken;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    isDashboardView() {
      return this.$route.path.endsWith("search");
    },
    isNewsView() {
      return this.$route.path == "/news";
    },
    showTopSearchComputed() {
      if (this.showTopSearch && (this.isDashboardView)) {
        return true;
      }
      return false;
    },
    showDateSearchComputed() {
      if (this.showDateSearch && !this.isNewsView) {
        return true;
      }
      return false;
    },
    isAdmin() {
      return this.$store.state.userRoles.includes("admin");
    },
    isEditor() {
      return this.$store.state.userRoles.includes("editor");
    },
    isOwner() {
      return this.$store.state.userRoles.includes("owner");
    },
    searchDateRangeText: {
      get: function () {
        if (!!this.search.dates && this.search.dates.length == 2) {
          return this.sortDateRange(this.search.dates).join(" ~ ");
        }
        return "";
      },
      set: function (newValue) {
        console.log(newValue);
      },
    },
    computedMenuItems() {
      let featured = [
        {
          text: "Principales Hechos",
          link: "/hechos/search",
        },
        {
          text: "Noticias",
          link: "/news",
        },
      ];
      if (this.isDefensoria) {
        featured.push(
          {
            text: "Delegadas",
            link: "/delegadas/search",
          },
          {
            text: "Étnicos",
            link: "/etnicos/search",
          },
          {
            text: "Normatividad",
            link: "/datasets/6f71c9a4-d6b4-45de-ba33-6117c73c4cf0/search",
          }
        );
      }
      let menuItems = [
        {
          icon: "mdi-star",
          text: "Destacados",
          children: featured,
        },
        { icon: "mdi-database", text: "Datos", link: "/datasets" },
        { icon: "mdi-finance", text: "Dashboards", link: "/dashboards" },
        { icon: "mdi-account", text: "Cuenta", link: "/profile" },
      ];
      let adminItems = [];
      if (this.isAdmin) {
        adminItems.push(
          ...[
            { text: "Cuentas", link: "/admin/accounts" },
            { text: "Usuarios", link: "/admin/users" },
            { text: "Estado", link: "/admin/status" },
          ]
        );
      } else if (this.isAdmin) {
        adminItems.push({ text: "Usuarios", link: "/admin/users" });
      }

      if (adminItems.length > 0) {
        menuItems.push({
          icon: "mdi-cog",
          text: "Administración",
          children: adminItems,
        });
      }

      menuItems.push({
        icon: "mdi-message",
        text: "Soporte",
        link: "/support",
      });
      menuItems.push({ icon: "mdi-cellphone-link", text: "CopraApp" });
      menuItems.push({
        icon: "mdi-logout",
        text: "Salir",
        click: () => {
          console.log("Logout");
          this.LOGOUT();
        },
      });

      return menuItems;
    },

    isDefensoria() {
      return (
        this.$store.state.accountUid === "1be9b5e6-13a1-4946-996d-6bd1d14b0409"
      );
    },
  },
};
</script>

<style scoped>
.v-application {
  background-color: var(--v-background-base) !important;
}
.v-snack__wrapper {
  min-width: 294px !important;
}
</style>